//tools
import { $static } from "../../tools/helpers";

//icons
import AiChatAvatar from "../../assets/ai-chat-avatar.svg";

//styles
import styles from "./Avatar.module.css";
import cc from "classcat";

const Avatar = ({ message, isCurrentUser }) => {
	if (message.type === "bot") {
		return (
			<img
				src={$static(AiChatAvatar)}
				alt='AI Avatar'
				className={styles["chat-avatar"]}
			/>
		);
	} else if (message.type === "user" && message.avatar && !isCurrentUser) {
		if (message.avatar.type === "abbreviation") {
			return (
				<div
					id='cng_ai_chat_user_avatar'
					className={cc([
						styles["chat-avatar"],
						`cng-bg-color-${message.avatar.color}`
					])}>
					<div className={styles["user-avatar-abbreviation"]}>
						{message.avatar.name}
					</div>
				</div>
			);
		} else if (message.avatar.type === "icon") {
			return (
				<div
					id='cng_ai_chat_user_avatar'
					className={styles["chat-avatar"]}>
					<div className='cng-app-header-user'>
						<span
							className={cc([
								styles["user-avatar-icon"],
								`cng-border-${message.avatar.color}`
							])}>
							<i
								className={cc([
									styles["cng-vector-icon"],
									"cng-vector-icon",
									`cng-vector-icon-${message.avatar.name}`,
									`cng-vector-icon-${message.avatar.color}`
								])}></i>
						</span>
					</div>
				</div>
			);
		}
	}

	return <></>;
};

export default Avatar;
